import { combineEpics } from 'redux-observable';
import fetchMembers from './fetchMembers';
import fetchRoleOptions from './fetchRoleOptions';
import createMember from './createMember';
import inviteMember from './inviteMember';
import acceptInvite from './acceptInvite';
import deleteMembers from './deleteMembers';
import updateMember from './updateMember';

export const membersEpic = combineEpics(
  fetchMembers,
  fetchRoleOptions,
  createMember,
  inviteMember,
  acceptInvite,
  deleteMembers,
  updateMember,
);
